// Central site configuration for the Halal GO marketing website.
// Keep external URLs and copy here so they are easy to update later.

export const SITE = {
  name: "Halal GO",
  microTagline: "Halal Made Easy",
  heroTagline: "Your Trusted Halal Food Delivery",
  footerLine: "Proudly in the Philippines. Serving Halal with Integrity.",
  supportLine: "Support Local. Eat Halal. Live Easy.",
  logo: "/brand/halalgo-logo.jpeg",
  email: "hello@halalgo.ph",
  phone: "+63 900 000 0000",
  location: "Metro Manila, Philippines",
  // The partner portal will eventually live on an external subdomain.
  // Flip `partnerPortalReady` to true to turn the Partner Login button into a
  // real external link (target=_blank) instead of the "Coming Soon" dialog.
  partnerPortalUrl: "https://admin.halalgo.ph",
  partnerPortalReady: false,
};

export const NAV_LINKS = [
  { label: "Home", to: "/", testId: "nav-home-link" },
  { label: "Blog", to: "/blog", testId: "nav-blog-link" },
  { label: "Download App", to: "/download", testId: "nav-download-link" },
  { label: "Contact Us", to: "/contact", testId: "nav-contact-link" },
];

export const SOCIALS = [
  { label: "Facebook", icon: "facebook", href: "#" },
  { label: "Instagram", icon: "instagram", href: "#" },
  { label: "YouTube", icon: "youtube", href: "#" },
  { label: "Email", icon: "mail", href: "#" },
];

export const TRUST_BADGES = [
  { icon: "shield", label: "100% Halal", sub: "Safe • Clean • Trusted" },
  { icon: "leaf", label: "Eco Packaging", sub: "Kraft, not plastic" },
  { icon: "heart", label: "Local Partners", sub: "Support local kitchens" },
];
